import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Navigation } from './components/Navigation';
import { HomePage } from './pages/HomePage';
import { BlogListingPage } from './pages/BlogListingPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { initializeGA, pageview } from './utils/googleAnalytics';
export function App() {
  useEffect(() => {
    // Initialize Google Analytics 4
    initializeGA();
    // Track initial page view
    pageview(window.location.pathname);
  }, []);
  return <Router data-id="element-0">
      <div className="w-full min-h-screen bg-gray-50" data-id="element-1">
        <Helmet data-id="element-2">
          <title data-id="element-3">
            I75 Audio & Video, LLC | Southwest Florida's Premier AV Solutions
          </title>
          <meta name="description" content="Southwest Florida's premier provider of audio, video, and smart technology solutions for homes and businesses. Home theater, commercial audio, camera systems, WiFi networks, and more." data-id="element-4" />
          <meta name="keywords" content="home theater, audio video, smart home, commercial audio, camera systems, WiFi networks, Southwest Florida, Cape Coral" data-id="element-5" />
          <meta property="og:title" content="I75 Audio & Video, LLC | Southwest Florida's Premier AV Solutions" data-id="element-6" />
          <meta property="og:description" content="Custom installations by experienced pros — Home Theater, Camera Systems, Whole Home Audio & Commercial AV." data-id="element-7" />
          <meta property="og:type" content="website" data-id="element-8" />
          <meta property="og:url" content="https://i75av.com" data-id="element-9" />
          <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/v7yfSfpEBAhNGcxDkT5ZNW/i75_transparent_PNG.png" data-id="element-10" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-11" />
          <link rel="canonical" href="https://i75av.com" data-id="element-12" />
        </Helmet>

        <Navigation data-id="element-13" />

        <Routes data-id="element-14">
          <Route path="/" element={<HomePage data-id="element-16" />} data-id="element-15" />
          <Route path="/blog" element={<BlogListingPage data-id="element-18" />} data-id="element-17" />
          <Route path="/blog/:slug" element={<BlogPostPage data-id="element-20" />} data-id="element-19" />
        </Routes>
      </div>
    </Router>;
}